import { render, staticRenderFns } from "./DetailStylist.vue?vue&type=template&id=2994cefb&scoped=true&"
import script from "./DetailStylist.vue?vue&type=script&lang=js&"
export * from "./DetailStylist.vue?vue&type=script&lang=js&"
import style0 from "./DetailStylist.vue?vue&type=style&index=0&id=2994cefb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2994cefb",
  null
  
)

export default component.exports